import React, { useEffect, useRef, useState } from 'react';
import styles from './deal.module.css';
import { textStyles } from '../../../constants/textStyles';
import HookForm from '../../../components/HookForm/HookForm';
import SelectClients from '../../../components/Selects/SelectClients';
import SelectDealStatuses from '../../../components/Selects/SelectDealStatuses';
import SelectPaymentTypes from '../../../components/Selects/SelectPaymentTypes';
import Modal from '../../../components/Modal/Modal';
import Cars from '../../Car/Cars';
import DealCreateCarsModal from './DealCreateCarsModal';
import CarCreate from '../../Car/NewCar/CarCreate';
import CarFixModal from '../../../components/Modals/CarFixModal';
import getCarMissingFields from '../../../utils/getCarMissingFields';
import SelectCreditPeriod from '../../../components/Selects/SelectCreditPeriod';
import DeleteButton from '../../../components/DeleteButton/DeleteButton';
import formatNumber from '../../../utils/formatNumber';
import ButtonEdit from '../../../components/Button/ButtonEdit';
import axios from 'axios';
import createDeal from '../../../api/deals/createDeal';
import { useLocation, useNavigate } from 'react-router-dom';
import editDeal from '../../../api/deals/editDeal';
import ButtonDelete from '../../../components/Button/ButtonDelete';
import removeItemsToDeal from '../../../api/deals/removeItemsToDeal';
import setStep from '../../../api/deals/setStep';
import addItemsToDeal from '../../../api/deals/addItemsToDeal';
import createNumberMask from '../../../utils/createNumberMask';
import SelectManager from '../../../components/Selects/SelectManager';
import LoaderInline from '../../../components/Loader/LoaderInline';
import { getErrorString } from '@microsoft/signalr/dist/esm/Utils';
import extractErrorMessage from '../../../utils/extractErrorMessage';
import alert from '../../../helpers/alert';
import { useSelector } from 'react-redux';
import { ROLE_MANAGER, ROLE_MOP } from '../../../constants/roles';
import AddButton from '../../../components/AddButton/AddButton';
import ClientCreateModal from '../../../components/ClientCreateModal/ClientCreateModal';
import Select from '../../../components/Select/Select';
import { isConsignmentOrigin } from '../../../constants/carOrigin';
import getBuInfo from '../../../api/shop/buInfo';
import { consignmentSellerOf, sellerOptionOf } from './consignmentSeller';
import { defaultPaymentOption } from './greySteps';

const DEFAULT_MANAGER_ROLE_IDS = [ROLE_MANAGER, ROLE_MOP];

const DealCreationMainInfo = ({ nextStep, deal, cars, update }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const formRef = useRef(null);
  const [clientModal, setClientModal] = useState(false);

  const [car, setCar] = useState(cars);

  // Ð£ Ð±/Ñ Ð°Ð²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ Ð¿ÑÐ¾Ð´Ð°Ð²ÐµÑ â ÐºÐ»Ð¸ÐµÐ½Ñ, Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð²ÑÐ¸Ð¹ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ.
  // ÐÐ¾Ð»Ðµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ: Ð¼ÐµÐ½ÑÑÑ ÐµÐ³Ð¾ Ð² ÑÐ´ÐµÐ»ÐºÐµ Ð½ÐµÐ»ÑÐ·Ñ, Ð¾Ð½Ð¾ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¼.
  // ÐÐ· ÑÐ»Ð¾Ñ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð²ÐµÑ Ð¿ÑÐ¸ÐµÐ·Ð¶Ð°ÐµÑ Ð²Ð¼ÐµÑÑÐµ Ñ Ð°Ð²ÑÐ¾, Ð¿ÑÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶Ðµ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ â
  // Ð´Ð¾ÑÑÐ³Ð¸Ð²Ð°ÐµÐ¼ Ð¸Ð· buInfo.
  const [fetchedSeller, setFetchedSeller] = useState(null);
  const passedSeller = car?.map((item) => consignmentSellerOf(item?.consignment)).find(Boolean);
  const consignmentSeller = passedSeller || fetchedSeller;

  // ÐÑÐ¾Ð´Ð°Ð²ÐµÑ â ÑÐ°ÐºÐ¾Ð¹ Ð¶Ðµ ÐºÐ»Ð¸ÐµÐ½Ñ Ð¸Ð· Ð±Ð°Ð·Ñ, ÐºÐ°Ðº Ð¸ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼
  // ÐµÐ³Ð¾ ÑÐµÐ»ÐµÐºÑÐ¾Ð¼, ÑÐ¾Ð»ÑÐºÐ¾ Ð·Ð°Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐ¼: Ð²ÑÐ±Ð¸ÑÐ°ÑÑ Ð½ÐµÑÐµÐ³Ð¾, Ð¾Ð½ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐ½ Ð°Ð²ÑÐ¾.
  // Ð£ ÑÐµÑÐ¾Ð³Ð¾ Ð´Ð¸Ð»ÐµÑÐ° Ð¿ÑÐ¾Ð´Ð°Ð²ÐµÑ â ÐÐ¦, Ð° Ð½Ðµ ÐºÐ»Ð¸ÐµÐ½Ñ: ÐµÐ³Ð¾ id Ð¸Ð· Ð´ÑÑÐ³Ð¾Ð¹ ÑÐ°Ð±Ð»Ð¸ÑÑ, Ð¸ÑÐºÐ»ÑÑÐ°ÑÑ Ð¿Ð¾ Ð½ÐµÐ¼Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð² Ð½ÐµÐ»ÑÐ·Ñ.
  const sellerOption = sellerOptionOf(consignmentSeller);
  const sellerIsClient = Boolean(consignmentSeller) && !consignmentSeller.isDc;

  useEffect(() => {
    if (passedSeller) return;
    const consignmentCar = car?.find((item) => isConsignmentOrigin(item?.originCarId));
    if (!consignmentCar?.id) {
      setFetchedSeller(null);
      return;
    }
    getBuInfo(consignmentCar.id)
      .then((res) => setFetchedSeller(consignmentSellerOf(res?.data?.consignment)))
      .catch(() => setFetchedSeller(null));
  }, [car, passedSeller]);

  const inputs = [
    {
      label: 'ÐÐ»Ð¸ÐµÐ½Ñ',
      name: 'clientId',
      component: SelectClients,
      // ÐÑÐ¾Ð´Ð°Ð²ÐµÑ ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð² ÑÑÐ¾Ð¹ Ð¶Ðµ ÑÐ´ÐµÐ»ÐºÐµ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»ÐµÐ¼.
      excludeIds: sellerIsClient ? [sellerOption.value] : undefined,
      rules: {
        required: !deal,
      },
      defaultValue: deal
        ? { value: deal?.client?.id, label: `${deal?.client?.name} ${deal?.client?.surname}` }
        : location?.state?.client
        ? {
            value: location?.state?.client?.id,
            label: `${location?.state?.client?.name} ${location?.state?.client?.surname}`,
          }
        : null,
    },
    {
      // ÐÐ»Ð¸ÐµÐ½ÑÐ° Ð¼Ð¾Ð¶Ð½Ð¾ Ð·Ð°Ð²ÐµÑÑÐ¸ Ð½Ðµ ÑÑÐ¾Ð´Ñ ÑÐ¾ ÑÐ´ÐµÐ»ÐºÐ¸ â Ð¼Ð¾Ð´Ð°Ð»ÐºÐ° Ð¾ÑÐ´Ð°ÑÑ Ð³Ð¾ÑÐ¾Ð²ÑÑ Ð¾Ð¿ÑÐ¸Ñ,
      // ÐºÐ¾ÑÐ¾ÑÑÑ ÑÑÐ°Ð·Ñ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÐ¼ Ð² ÑÐµÐ»ÐµÐºÑ Ð²ÑÑÐµ.
      name: 'addClient',
      component: AddButton,
      text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
      onClick: (e) => {
        e.preventDefault();
        setClientModal(true);
      },
    },
    {
      label: 'Ð¡Ð¿Ð¾ÑÐ¾Ð± Ð¾Ð¿Ð»Ð°ÑÑ',
      name: 'paymentTypeId',
      component: SelectPaymentTypes,
      rules: {
        required: !deal,
      },
      defaultValue: deal ? { value: deal?.paymentType?.id, label: deal?.paymentType?.title } : defaultPaymentOption(),
    },

    {
      label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
      name: 'managerId',
      component: SelectManager,
      rules: {
        required: true,
      },
      defaultValue: DEFAULT_MANAGER_ROLE_IDS.includes(user?.roleId)
        ? {
            value: user?.id,
            label: `${user?.name} ${user?.surname}`,
          }
        : null,
    },

    // {
    //   label: 'ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ',
    //   name: 'initialFee',
    //   dependency: ['paymentTypeId', 'car'],
    //   dependencyAccessor: (obj) => obj[0]?.value,
    //   placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð¿ÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ',
    //   isCredit: true,
    //   hide: () => !car?.length,
    //   mask: createNumberMask({
    //     allowDecimal: true,
    //     prefix: '',
    //     thousandsSeparatorSymbol: ' ',
    //     decimalLimit: 0,
    //   }),
    //   rules: {
    //     valueAsNumber: true,
    //     validate: (value, getValues) => {
    //       value = value?.replace(/\s/g, '');
    //       value = parseInt(value);
    //       if (!car?.length) return true;
    //       const paymentTypeId = getValues('paymentTypeId');
    //       if (paymentTypeId?.value !== 6 && paymentTypeId?.value !== 7) {
    //         return true;
    //       }

    //       let error = true;
    //       const carPrice = car?.reduce((acc, item) => acc + item?.price, 0);
    //       if (value < (carPrice * 0.1)?.toFixed(0)) {
    //         error = `ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð°Ñ ÑÑÐ¼Ð¼Ð° Ð²Ð·Ð½Ð¾ÑÐ° 10% Ð¾Ñ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ`;
    //       } else if (value > carPrice) {
    //         error = 'Ð¡ÑÐ¼Ð¼Ð° Ð²Ð·Ð½Ð¾ÑÐ° Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð¿ÑÐµÐ²ÑÑÐ°ÑÑ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ';
    //       } else if (isNaN(value)) {
    //         error = 'ÐÐ¾Ð»Ðµ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ';
    //       } else {
    //         error = true;
    //       }

    //       return error;
    //     },
    //   },
    // },
    // {
    //   label: 'Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ, Ð¼ÐµÑÑÑÐµÐ²',
    //   name: 'period',
    //   component: SelectCreditPeriod,
    //   dependency: 'paymentTypeId',
    //   dependencyAccessor: (obj) => obj?.value,
    //   hide: () => !car?.length,
    //   rules: {
    //     deps: ['paymentTypeId', 'car'],
    //     validate: (value, getValues) => {
    //       if (!car?.length) return true;
    //       const paymentTypeId = getValues('paymentTypeId');
    //       let error = true;

    //       if (!value && (paymentTypeId?.value === 6 || paymentTypeId?.value === 7)) {
    //         error = 'ÐÐ¾Ð»Ðµ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ';
    //       } else {
    //         error = true;
    //       }

    //       return error;
    //     },
    //   },
    // },
  ];
  const [carsModal, setCarsModal] = useState(false);
  const openCarsModal = () => {
    setCarsModal(true);
  };

  const [fixQueue, setFixQueue] = useState([]);

  // ÐÐ²ÑÐ¾ Ð·Ð°Ð²Ð¾Ð´ÑÑ Ð¿ÑÑÐ¼Ð¾ Ð¸Ð· Ð¾ÐºÐ½Ð° Ð²ÑÐ±Ð¾ÑÐ°: ÑÐ¾ÑÐ¼Ð° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑÑÑ Ð¿Ð¾Ð²ÐµÑÑ ÑÐ´ÐµÐ»ÐºÐ¸, Ð° ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ðµ Ð°Ð²ÑÐ¾
  // ÑÑÐ°Ð·Ñ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÐµÑ Ð² Ð½ÐµÑ â Ð´Ð°Ð½Ð½ÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸ Ð½Ðµ ÑÐµÑÑÑÑÑÑ.
  const [addCarModal, setAddCarModal] = useState(false);
  const onCarCreatedInline = (created) => {
    setAddCarModal(false);
    onCarsFormSubmit([...(car || []).filter((item) => item.id !== created.id), created]);
  };

  const onCarsFormSubmit = (cars) => {
    const currentYear = new Date().getFullYear();
    const problematicCars = cars.filter(car => car.issueYear > currentYear || isNaN(car.issueYear) || car.issueYear < 1900);
    if (problematicCars.length > 0) {
      return alert.error(`ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð³Ð¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ° Ð°Ð²ÑÐ¾ ${problematicCars.map(car => `${car.mark} ${car.model} (${car.vin})`).join(', ')}.`);
    }

    // ÐÐ±ÑÑÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ ÑÑÐ¾Ð´Ð¸Ñ Ð² Ð±Ð°Ð½ÐºÐ¸: Ð¾Ð½Ð¸ Ð¸ÑÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ,
    // Ð¼Ð¾Ð´ÐµÐ»Ð¸, Ð³Ð¾Ð´Ñ Ð¸ Ð¾Ð±ÑÑÐ¼Ñ ÑÑÐ°Ð·Ñ. ÐÑÑÑÐ¾Ð¹ Ð¾Ð±ÑÑÐ¼ Ð»Ð¾Ð²Ð¸ÑÑÑ Ð½Ð¸Ð¶Ðµ ÐºÐ°Ðº Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾Ðµ Ð¿Ð¾Ð»Ðµ,
    // Ð° Ð½ÐµÐ²ÐµÑÐ½ÑÐ¹ Ð²Ð¸Ð´ÐµÐ½ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ ÑÐ°ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸ÐµÐ¹ â Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÐµÐ¼ Ð·Ð´ÐµÑÑ,
    // Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð½Ð° ÑÐ°Ð³Ðµ Ð²ÑÐ±Ð¾ÑÐ° Ð±Ð°Ð½ÐºÐ¾Ð² Ð·Ð°ÑÐ²ÐºÐ° ÑÐ¶Ðµ ÑÑÐ¾Ð´Ð¸Ñ Ð¸ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ Ð¾ÑÐºÐ°Ð· Ð¤Ð¾ÑÑÐµ.
    const wrongVolume = cars.filter((car) => car.engineVolumeWarning);
    if (wrongVolume.length > 0) {
      wrongVolume.forEach((car) =>
        alert.error(`${car.mark} ${car.model}: ${car.engineVolumeWarning}`, {
          autoClose: false,
          closeOnClick: false,
        })
      );
    }

    const checked = cars.map((car) => ({ car, missing: getCarMissingFields(car) }));
    const ready = checked.filter((item) => item.missing.length === 0).map((item) => ({ ...item.car, n: true }));
    const incomplete = checked.filter((item) => item.missing.length > 0);

    setCarsModal(false);
    setCar(ready);

    if (incomplete.length > 0) {
      setFixQueue(incomplete);
      alert.error(
        `${incomplete.length > 1 ? 'Ð£ Ð½ÐµÐºÐ¾ÑÐ¾ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹' : 'Ð£ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ'} Ð½Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÐµ Ð¿Ð¾Ð»Ñ. ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð¸Ñ Ð² Ð¾ÑÐºÑÑÐ²ÑÐµÐ¼ÑÑ Ð¾ÐºÐ½Ðµ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ${
          incomplete.length > 1 ? 'Ð¸Ñ' : 'ÐµÐ³Ð¾'
        } Ð² ÑÐ´ÐµÐ»ÐºÑ.`
      );
    }
  };

  const handleCarFixed = (updatedCar) => {
    const missing = getCarMissingFields(updatedCar);
    if (missing.length > 0) {
      setFixQueue((prev) => {
        if (!prev.length) return prev;
        const [, ...rest] = prev;
        return [{ car: updatedCar, missing }, ...rest];
      });
      return;
    }

    setCar((prev) => {
      const existing = prev || [];
      if (existing.some((item) => item.id === updatedCar.id)) return existing;
      return [...existing, { ...updatedCar, n: true }];
    });
    alert.success(`ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ ID${updatedCar?.id} Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½ Ð² ÑÐ´ÐµÐ»ÐºÑ`);
    setFixQueue((prev) => prev.slice(1));
  };

  const handleSkipFix = () => {
    const current = fixQueue[0];
    if (current) {
      alert.error(`ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ ID${current.car?.id} Ð½Ðµ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½ Ð² ÑÐ´ÐµÐ»ÐºÑ â Ð´Ð°Ð½Ð½ÑÐµ Ð½Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ.`);
    }
    setFixQueue((prev) => prev.slice(1));
  };

  const handleSubmit = (values) => {
    setLoading(true);
    console.log(values);
    const payload = {
      deal: {
        ...values,
        clientId: values?.clientId?.value,
        statusId: values?.statusId?.value,
        paymentTypeId: values?.paymentTypeId?.value,
        managerId: values?.managerId?.value,
      },
      options: {
        cars: car?.map((car) => ({ value: car.id })),
        clientId: values?.clientId?.value,
      },
    };

    // if (values?.paymentTypeId?.value === 6 || values?.paymentTypeId?.value === 7) {
    //   values.initialFee = values?.initialFee?.replace(/\s/g, '');
    //   values.initialFee = parseInt(values?.initialFee);
    //   payload.credit = {
    //     period: Number(values?.period?.value),
    //     initialFee: values?.initialFee,
    //   };
    // }
    if (deal?.id) {
      editDeal({
        clientId: values?.clientId?.value || deal?.client?.id,
        statusId: values?.statusId?.value,
        paymentTypeId: values?.paymentTypeId?.value,
        id: deal?.id,
        dealId: deal?.id,
      })
        .then(() => {
          if (car?.filter((item) => item?.n)?.length) {
            addItemsToDeal({
              cars: car?.map((car) => ({ value: String(car.id) })),
              dealId: String(deal?.id),
              step: 2,
              clientId: values?.clientId?.value || deal?.client?.id,
            })
              .then(() => {
                nextStep();
              })
              .catch((err) => alert(err));
          } else {
            setStep({ dealId: String(deal?.id), step: 2 }).then(() => {
              update();
            });
          }
        })
        .finally(() => setLoading(false));
    } else {
      createDeal(payload)
        .then((res) => {
          nextStep(res?.data);
          navigate(`/deals/deal/${res?.data}/main-info`);
        })
        .catch((err) => {
          alert.error(extractErrorMessage(err?.data) || 'ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ð¸ ÑÐ´ÐµÐ»ÐºÐ¸');
        })
        .finally(() => setLoading(false));
    }
  };

  const handleCarDelete = (item) => {
    if (item?.n) {
      const newCars = car.filter((car) => car.id !== item.id);
      console.log(newCars);
      setCar(newCars);
    } else {
      removeItemsToDeal({
        cars: [{ value: String(item?.orderId) }],
        dealId: String(deal?.id),
      }).then(() => {
        update();
      });
    }
  };

  useEffect(() => {
    setCar(cars);
  }, [cars]);

  useEffect(() => {
    if (location?.state?.car) {
      onCarsFormSubmit([location?.state?.car]);
    }
  }, [location]);

  const [touched, setTouched] = useState(false);

  // ÐÐ»Ð¸ÐµÐ½ÑÐ° Ð¼Ð¾Ð³Ð»Ð¸ Ð²ÑÐ±ÑÐ°ÑÑ Ð´Ð¾ ÑÐ¾Ð³Ð¾, ÐºÐ°Ðº Ð² ÑÐ´ÐµÐ»ÐºÑ Ð´Ð¾Ð±Ð°Ð²Ð¸Ð»Ð¸ ÐµÐ³Ð¾ Ð¶Ðµ Ð°Ð²ÑÐ¾ â Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°
  // Ð¾Ð½ ÑÐ¶Ðµ Ð¾ÑÑÐ¸Ð»ÑÑÑÐ¾Ð²Ð°Ð½, Ð½Ð¾ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¼ Ð¾ÑÑÐ°Ð»ÑÑ. Ð¡Ð½Ð¸Ð¼Ð°ÐµÐ¼ Ð²ÑÐ±Ð¾Ñ Ð¸ Ð³Ð¾Ð²Ð¾ÑÐ¸Ð¼ Ð¿Ð¾ÑÐµÐ¼Ñ:
  // Ð¼Ð¾Ð»ÑÐ° Ð¿ÑÐ¾Ð¿Ð°Ð²ÑÐµÐµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð½Ð¾Ðµ Ð¿Ð¾Ð»Ðµ Ð²ÑÐ³Ð»ÑÐ´Ð¸Ñ ÐºÐ°Ðº Ð±Ð°Ð³.
  useEffect(() => {
    if (!sellerIsClient) return;
    if (formRef.current?.getValues('clientId')?.value !== sellerOption.value) return;
    formRef.current.setValue('clientId', null);
    alert.error('ÐÑÐ¾Ð´Ð°Ð²ÐµÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»ÐµÐ¼ Ð² ÑÑÐ¾Ð¹ Ð¶Ðµ ÑÐ´ÐµÐ»ÐºÐµ');
  }, [sellerOption?.value]);

  return (
    <>
      {/* <p style={{ ...textStyles.formTitle, marginBottom: 20 }}>ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ</p> */}
      <HookForm
        ref={formRef}
        inputs={inputs}
        title={'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ'}
        grid={{ display: 'grid', gap: 20 }}
        onSubmit={(values) => {
          if (car?.length) {
            setTouched(false);
            handleSubmit(values);
          } else {
            setTouched(true);
          }
        }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        customData={() =>
          car?.length ? (
            <div style={{ display: 'grid', gap: 20 }}>
              {sellerOption && (
                <Select
                  title="ÐÑÐ¾Ð´Ð°Ð²ÐµÑ"
                  hint="Ð¡Ð¾Ð±ÑÑÐ²ÐµÐ½Ð½Ð¸Ðº Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ. ÐÐ¿ÑÐµÐ´ÐµÐ»ÑÐµÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¼, Ð² ÑÐ´ÐµÐ»ÐºÐµ Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑÑÑ."
                  options={[sellerOption]}
                  value={sellerOption}
                  disabled
                />
              )}
              <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '0 20px', alignItems: 'center' }}>
                <p>ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ:</p>
                {car.map((car) => {
                  return (
                    <div
                      key={car.id}
                      style={{
                        gridColumn: '2/2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      ID{car?.id} {car?.mark} {car?.model} {car?.complectation?.title} {car?.issueYear}{' '}
                      {car?.price ? '(' + formatNumber(car?.price) + ' â¸)' : ''}{' '}
                      <ButtonDelete onClick={() => handleCarDelete(car)} />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null
        }
        addCustomItemTitle="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸"
        handleAddCustomItem={openCarsModal}
        error={car?.length > 0 || !touched ? false : 'ÐÐ¾Ð±Ð°Ð²ÑÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ'}
        loading={loading}
      />
      <ClientCreateModal
        isOpen={clientModal}
        onRequestClose={() => setClientModal(false)}
        onCreated={(option) => formRef.current?.setValue('clientId', option)}
      />
      <DealCreateCarsModal
        isOpen={carsModal}
        onRequestClose={() => setCarsModal(false)}
        onSubmit={onCarsFormSubmit}
        onCancel={() => setCarsModal(false)}
        onAddCar={() => setAddCarModal(true)}
      />
      <Modal isOpen={addCarModal} onRequestClose={() => setAddCarModal(false)}>
        <CarCreate onCreated={onCarCreatedInline} />
      </Modal>
      <CarFixModal
        isOpen={fixQueue.length > 0}
        car={fixQueue[0]?.car}
        missingFields={fixQueue[0]?.missing}
        remainingCount={fixQueue.length}
        onFixed={handleCarFixed}
        onSkip={handleSkipFix}
      />
    </>
  );
};

export default DealCreationMainInfo;
